import HttpsIcon from '@mui/icons-material/Https';
import { Box, Typography, useTheme } from '@mui/material';
import type { Theme } from '@mui/material';
import type { SxProps } from '@mui/system';
import type { FC } from 'react';

type Props = {
  featureName: string;
  // Each line renders on its own row, so the copy wraps where it was written to.
  promoLines: string[];
  sx: SxProps<Theme>;
};

export const NewFeatureHeader: FC<Props> = ({ featureName, promoLines, sx }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        ...sx,
      }}
    >
      <Box
        sx={{
          backgroundColor: '#E5E7EA',
          width: '100px',
          height: '100px',
          borderRadius: '100px',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          color: theme.palette.SlabGray[600],
        }}
      >
        <HttpsIcon sx={{ width: '32px', height: '32px' }} />
      </Box>
      <Typography variant='h1' sx={{ marginTop: '12px', marginBottom: '8px' }}>
        {`Unlock ${featureName}`}
      </Typography>
      {promoLines.map((line) => (
        <Typography variant='h2' key={line} sx={{ color: theme.palette.SlabGray[600] }}>
          {line}
        </Typography>
      ))}
      <Box
        sx={{
          width: '100px',
          height: '2px',
          backgroundColor: theme.palette.SlabGray[400],
          marginTop: '20px',
          marginBottom: '20px',
        }}
      />
      <Typography variant='h5' color={theme.palette.SlabGray[950]}>
        Email <a href='mailto:sales@sysdynetechnologies.com'>sales@sysdynetechnologies.com</a> for
        pricing.
      </Typography>
    </Box>
  );
};
